import { render, staticRenderFns } from "./peopleReg.vue?vue&type=template&id=7649f4da&"
import script from "./peopleReg.vue?vue&type=script&lang=js&"
export * from "./peopleReg.vue?vue&type=script&lang=js&"
import style0 from "./peopleReg.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports